import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1 mx-auto max-w-3xl px-6 py-32 text-center">
        <p className="num text-7xl font-semibold text-ink-300">404</p>
        <h1 className="mt-4 text-2xl font-semibold text-ink-900">{t('common.not_found_title')}</h1>
        <p className="mt-2 text-ink-600">{t('common.not_found_sub')}</p>
        <Link
          to="/"
          className="mt-6 inline-flex px-4 py-2 rounded-lg bg-accent-500 text-white text-sm font-semibold hover:bg-accent-600"
        >
          {t('common.back_home')}
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}
